import { INVENTORY_STATUS_SAVE_FILTERS } from "../types";
import { fetchAllDashboardFilters, extractDashboardFilters, saveDashboardFilters } from "../../utils/filterUtils";

/**
 * Fetch filters for the inventory status dashboard
 */
export const fetchInventoryStatusFilters = () => async (dispatch) => {
  try {
    // Use the new unified API to fetch all filters
    const allFilters = await fetchAllDashboardFilters();
    
    // Extract the inventory status dashboard filters
    const inventoryFilters = extractDashboardFilters(allFilters, 'inventoryStatusDashboard');
    
    dispatch({
      type: INVENTORY_STATUS_SAVE_FILTERS,
      payload: inventoryFilters
    });
    
    return inventoryFilters;
  } catch (err) {
    console.error("Error fetching inventory status filters:", err);
    dispatch({
      type: INVENTORY_STATUS_SAVE_FILTERS,
      payload: { status: false }
    });
    return { status: false };
  }
};

/**
 * Save inventory status dashboard filters
 * @param {Object} filterData - Filter data to save
 */
export const saveInventoryStatusFilters = (filterData) => async (dispatch) => {
  try {
    // Save filters using the unified API
    await saveDashboardFilters('inventoryStatusDashboard', filterData);
    
    //dispatch(fetchInventoryStatusFilters());
    return { status: true, message: "Filters saved successfully" };
  } catch (err) {
    console.error("Error saving inventory status filters:", err);
    dispatch({
      type: INVENTORY_STATUS_SAVE_FILTERS,
      payload: { 
        status: false, 
        errorDescription: "Failed to save filters. Please try again later."
      }
    });
    return { status: false, message: "Failed to save filters" };
  }
};

/**
 * Fetch filters for the inventory reconciliation dashboard
 */
export const fetchInventoryReconciliationFilters = () => async (dispatch) => {
  try {
    // Use the new unified API to fetch all filters
    const allFilters = await fetchAllDashboardFilters();
    
    // Extract the inventory reconciliation dashboard filters
    const reconciliationFilters = extractDashboardFilters(allFilters, 'inventoryReconciliationDashboard');
    
    return reconciliationFilters;
  } catch (err) {
    console.error("Error fetching inventory reconciliation filters:", err);
    return { status: false };
  }
};

/**
 * Save inventory reconciliation dashboard filters
 * @param {Object} filterData - Filter data to save
 */
export const saveInventoryReconciliationFilters = (filterData) => async () => {
  try {
    // Save filters using the unified API
    const result = await saveDashboardFilters('inventoryReconciliationDashboard', filterData);
    return result;
  } catch (err) {
    console.error("Error saving inventory reconciliation filters:", err);
    return { 
      status: false, 
      message: "Failed to save filters. Please try again later."
    };
  }
};
